enum CivilCodeInterest {
  NOT_APPLY = 'not_apply',
  ONE_PERCENT = 'one_percent',
  ADMINISTRATIVE_NATURE = 'administrative_nature',
  PUBLIC_EMPLOYEES = 'public_employees',
  SAVINGS = 'savings',
  SELIC_ACCUMULATED = 'selic_accumulated',
  SELIC_CAPITALIZED = 'selic_capitalized',
  SELECT_INDEX = 'select_index',
  MONTHLY_BEFORE_LAW = 'monthly_before_law',
  PRO_RATA_DAY_BEFORE_LAW = 'pro_rata_day_before_law',
}

export default CivilCodeInterest;
